import { observer } from "mobx-react-lite"
import { useProposalsEditDetailsStore } from "./ProposalsEditDetailsStore"
import Typography from "@mui/material/Typography"
import FileUploadWithProgress from "reusable/mui/file-uploads/FileUploadWithProgress"
import AutocompleteSingle from "reusable/mui/auto-complete/AutocompleteSingle"
import Box from "@mui/material/Box"
import SkeletonLoader from "reusable/mui/skeleton/SkeletonLoader"
import { useTheme } from "theme/useTheme"

export default observer(function ProposalsEditDetailsTOE() {
   const proposalsEditDetailsStore = useProposalsEditDetailsStore()
   const theme = useTheme()

   return <>
      <Typography variant="subtitle1">Upload your Terms of Engagement</Typography>
      <Typography variant="caption">Upload a PDF of your Terms of Engagement. This is recommended when first engaging with a client, or if you’re renewing a contract.</Typography>

      <SkeletonLoader loading={proposalsEditDetailsStore.existingTOEFileLoader.isLoading}>
         {proposalsEditDetailsStore.existingTOEFiles.length > 0 && proposalsEditDetailsStore.formHandler.selectedFilename.bindInput(ip =>
            <AutocompleteSingle
               variant='outlined'
               label="Choose from your saved Terms of Engagement"
               options={proposalsEditDetailsStore.selectFileOptions}
               {...ip}
               sx={{ mt: theme.spacing(3) }}
            />
         )}
      </SkeletonLoader>

      <Box sx={{ mt: theme.spacing(3) }}>
         <FileUploadWithProgress
            maxFiles={1}
            files={proposalsEditDetailsStore.fileUpload.files}
            subtext="PDF (max. 10MB)"
            getPresignedUrl={proposalsEditDetailsStore.getUploadUrl}
            accept={{ "application/pdf": ['.pdf'], }}
            onFilesValidated={proposalsEditDetailsStore.newFile}
            onFileRemove={proposalsEditDetailsStore.removeFile}
            formatFile={true}
         />
      </Box>
   </>
})
